import { render, staticRenderFns } from "./AllPaymentRecord.vue?vue&type=template&id=6222a590&scoped=true&"
import script from "./AllPaymentRecord.vue?vue&type=script&lang=js&"
export * from "./AllPaymentRecord.vue?vue&type=script&lang=js&"
import style0 from "./AllPaymentRecord.vue?vue&type=style&index=0&id=6222a590&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6222a590",
  null
  
)

export default component.exports